const production = {
	url: "https://world-api.smesj.world/footy",
	wsUrl: "https://world-api.smesj.world",
};

const development = {
	url: "http://localhost:3003/footy",
	wsUrl: "http://localhost:3003",
};
export const config =
	process.env.NODE_ENV === "development" ? development : production;
